import React, { useEffect, useState } from 'react';
import './team-view.styles.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import PlayerNameIcon from '@/components/PLAYER/player-blocks/components/status-elements/player-name-icon.component';
import { sortPlayers } from '@/utils/sortPlayers';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TeamView = ({
  gameData,
  playerList,
}) => {

  const { teamPath } = useParams();
  const [teamData, setTeamData] = useState(null);
  const [ teamMemberList, setTeamMemberList ] = useState([]);
  const [ totalTeamPlayerPoints, setTotalTeamPlayerPoints ] = useState(0);
  const [ teamEarnedPoints, setTeamEarnedPoints ] = useState(0);
  const navigate = useNavigate();
  let teamListener;

  useEffect(() => {

    return () => {
      if (teamListener) teamListener();
    }
  }, [])

  useEffect(() => {
    if (!teamPath || !gameData) return;
    console.log(teamPath);
    getTeamData();
  }, [teamPath, gameData])

  useEffect(() => {
    if (!teamData || !playerList) return;
    const membersArr = [];
    Object.values(playerList).forEach(p => {
      if (teamData.opt_members.includes(p.playerId)) {
        membersArr.push(p);
      }
    });
    const sortedPlayers = sortPlayers({
      'playerList': membersArr, 
      'filter': 'players'
    })
    setTeamMemberList(sortedPlayers);
    setTotalTeamPlayerPoints(
      sortedPlayers.reduce((total, p) => {
        return total + (p.points || 0)
      }, 0)
    )
  }, [teamData, playerList])

  function getTeamData() {
    getQueryFromFirestore({
      'path': `games/${gameData.gameId}/players/`,
      'queryArray': [{
        'field': 'path',
        'operator': '==',
        'value': teamPath
      }],
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      console.log(data);
      setTeamData(data);
    }
    function handleListener(unsub) {
      teamListener = unsub;
    }
  }

  return (
    <div className='team-view-container'>
      {
        teamData &&
        <div className='team-view-content'>
          <div className='team-view-header'>
            <ImageContainer
              src={teamData.icon}
              className='team-icon' />
            <h2>{teamData.name}</h2>
            <div className='buttons'>
              <button
                className='g-button med-btn'
                onClick={() => navigate(`edit`)} >
                Edit
              </button>
            </div>
          </div>
          <div className='team-points g-list-item'>
            <h3>
              Total Member Points:
              <div className='team-point-amount'>
                <ImageContainer src="/images/xp.png" className="xp-icon" />
                {totalTeamPlayerPoints}
              </div>
            </h3>
            <h3>
              Team Points:
              <div className='team-point-amount'>
                <ImageContainer src="/images/xp.png" className="xp-icon" />
                {teamEarnedPoints}
              </div>
            </h3>
          </div>
          <div className='team-player-list-container'>
            <h3>Team Members</h3>
            <div className='team-player-list'>
            {
              (teamMemberList.length > 0)
                ?
                teamMemberList.map(m => {
                  const playerInfo = playerList[m.playerId];
                  return (
                    <div key={m.playerId} className='team-member'>
                      <PlayerNameIcon
                        player={playerInfo}
                        reverse={true} />
                      <div className='member-points'>
                        <ImageContainer src="/images/xp.png" className="xp-icon" />
                        {playerInfo.points || 0}
                      </div>
                      <div className='member-points'>
                        <ImageContainer src="/images/icons/coin.png" className="xp-icon" />
                        {playerInfo.currency || 0}
                      </div>
                      <div className='member-points'>
                        <ImageContainer src="/images/icons/coins.png" className="xp-icon" />
                        {playerInfo.currencyTotal || 0}
                      </div>
                      <div className="buttons">
                        <button 
                          className='g-button small-btn' 
                          onClick={() => navigate(`/manage/${gameData.path}/players/${m.path}`)}>
                          <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                      </div>
                    </div>
                  )
                })
                :
                <span>No members have been added to this team yet.</span>
              }
              </div>
          </div>
        </div>
      }
    </div>
  )
}

export default TeamView